export default __webpack_public_path__ + "static/media/branding_l.a9dd9a0f.jpg";